export default {
  getAllCountries: state => state.countries.map(item => ({
    value: item.id,
    label: item.name,
  })),

  getAllStates: state => state.states.map(item => ({
    value: item.id,
    label: item.name,
  })),
};
